import { ChevronLeft, ChevronRight } from 'lucide-react'
import styles from './TablePagination.module.css'

type PageSizeConfig = {
  label?: string
  onChange: (pageSize: number) => void
  options: number[]
  value: number
}

type TablePaginationProps = {
  ariaLabel?: string
  className?: string
  currentPage: number
  isNextDisabled?: boolean
  isPreviousDisabled?: boolean
  nextLabel?: string
  onNext: () => void
  onPrevious: () => void
  pageLabel?: string
  pageSize?: PageSizeConfig
  previousLabel?: string
  summary?: string
  totalPages: number
}

export const TablePagination = ({
  ariaLabel,
  className,
  currentPage,
  isNextDisabled,
  isPreviousDisabled,
  nextLabel = 'Next page',
  onNext,
  onPrevious,
  pageLabel,
  pageSize,
  previousLabel = 'Previous page',
  summary,
  totalPages
}: TablePaginationProps) => (
  <div
    aria-label={ariaLabel}
    className={[styles.pagination, className].filter(Boolean).join(' ')}
  >
    {summary && <span className={styles.summary}>{summary}</span>}
    <div className={styles.controls}>
      {pageSize && (
        <label className={styles.pageSize}>
          <span>{pageSize.label ?? 'Rows'}</span>
          <select
            aria-label="Rows per page"
            className="form-input select-input"
            onChange={(event) => pageSize.onChange(Number(event.target.value))}
            value={pageSize.value}
          >
            {pageSize.options.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </label>
      )}
      <button
        aria-label={previousLabel}
        className={styles.button}
        disabled={isPreviousDisabled ?? currentPage <= 1}
        onClick={onPrevious}
        type="button"
      >
        {previousLabel === 'Previous' ? previousLabel : <ChevronLeft size={15} />}
      </button>
      <span className={styles.pageLabel}>{pageLabel ?? `Page ${currentPage} of ${totalPages}`}</span>
      <button
        aria-label={nextLabel}
        className={styles.button}
        disabled={isNextDisabled ?? currentPage >= totalPages}
        onClick={onNext}
        type="button"
      >
        {nextLabel === 'Next' ? nextLabel : <ChevronRight size={15} />}
      </button>
    </div>
  </div>
)
